module.exports = __webpack_public_path__ + "static/img/help_center.209cef24.png";